import { render, staticRenderFns } from "./OptionDetails.vue?vue&type=template&id=1754e57e&"
import script from "./OptionDetails.vue?vue&type=script&lang=ts&"
export * from "./OptionDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports